<template>
    <div>
        <div class="mindex">
            <div class="top">
                <img src="../../assets/phoneimg/nav_logo.png" alt="">
                <mu-icon class="menu" value="dehaze" @click="changenooof(0)"></mu-icon>
            </div>
            <div class="menu-list" :style="'right:'+nooof+'rem'">
                <div class="menu-top">
                    <img src="../../assets/phoneimg/nav_logo.png"  alt="">
                    <mu-icon class="menu" value="close" @click="changenooof(1)"></mu-icon>
                </div>
                <h2 :class="active[0]" @click="changeactive(0)">首页</h2>
                <h2 :class="active[1]" @click="changeactive(1)">解决方案</h2>
                <div>
                    <mu-expansion-panel  style="margin: 0; border-bottom: 1px solid #d0d0d0;box-shadow: 0px 0px 0px #fff;">
                        <div class="menu-pull" slot="header">产品中心</div>
                        <ul class="item">
                            <li :class="active[2]" @click="changeactive(2)">店铺装修</li>
                            <li :class="active[3]" @click="changeactive(3)">拼团</li>
                            <li :class="active[4]" @click="changeactive(4)">在线客服系统</li>
                            <li :class="active[5]" @click="changeactive(5)">电子卡密</li>
                        </ul>
                    </mu-expansion-panel>
                </div>
<!--                <h2 :class="active[6]" @click="changeactive(6)">帮助中心</h2>-->
            </div>
            <div class="zhegai" :style="disp" @click="changenooof(1)"></div>
        </div>
        <router-view/>
        <div class="btmcall" @click="call">
            <img src="../../assets/phoneimg/phone_.png" alt="">
            <span>联系我们</span>
        </div>
    </div>

</template>
<script>
    export default {
        name: 'mindex',
        data(){
            return{
                nooof:-16.875,
                disp:'display:none',
                active:['active','','','','','']
            }
        },
        methods:{
            changenooof(i){
                this.nooof=i*(-16.875)
                if(i==0){
                    this.disp=''
                }else{
                    this.disp='display:none'
                }
            },
            changeactive(k){
                for (var i = 0 ;i<this.active.length;i++){
                    this.$set(this.active,i, '');
                }
                this.$set(this.active,k, 'active');
                if(k==0){
                    this.$router.push({name:'mmid'})
                }else if (k==6){
                    this.$router.push({name:'mhelp'})
                }else if(k==2){
                    this.$router.push({name:'pzhuangxiu'})
                }else if(k==3){
                    this.$router.push({name:'ppintuan'})
                }else if(k==4){
                    this.$router.push({name:'pkefu'})
                }else if(k==5){
                    this.$router.push({name:'pkami'})
                }else if (k==1){
                    this.$router.push({name:'pjiejue'})
                }
                this.disp='display:none'
                this.nooof=-16.875
            },
            call(){
                for (var i = 0 ;i<this.active.length;i++){
                    this.$set(this.active,i, '');
                }
                this.$router.push({name:'call'})
            }
        }
    }
</script>
<style scoped>
   .top{
       width: 100%;
       height: 3rem;
       top: 0;
       position: fixed;
       z-index: 7;
       background: #fff;
       border-bottom: 1px solid #eee;
   }
   .top>img{
       width: 14.96875rem;
       /* height: 100%; */
       display: block;
       position: absolute;
       left: 0;
       right: 0;
       margin: auto;
       height: auto;
       top: 0;
       bottom: 0;
   }
    .menu{
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 0.75rem;
        width: 1.5rem;
        height: 1.5rem;
    }
    .menu-list{
        position: fixed;
        width: 16.875rem;
        height: 100%;
        background: #fff;
        right: 0;
        top: 0;
        z-index: 9;
        transition: all .35s;
    }
    .zhegai{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 8;
        background-color: rgba(0,0,0,.7);
    }
    .menu-top{
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
        height: 3rem;
        position: relative;
    }
    .menu-top>img{
        width: 14.96875rem;
        margin-right: 6.75rem;
        position: absolute;
        top: 0;
        left: 1rem;
        bottom: 0;
        margin: auto;
    }
    .menu-list>h2{
        font-size: .875rem;
        line-height: .875rem;
        margin: .875rem 0 .875rem 0;
        box-sizing: border-box;
        padding: 0 0 0 1.125rem;
        color: #3b426b;
        font-weight: 600;
        text-align: left;
    }
    .menu-pull{
        font-size: .875rem;
        line-height: .875rem;
        margin: .875rem 0 .875rem -0.25rem;
        box-sizing: border-box;
        color: #3b426b;
        font-weight: 600;
        text-align: left;
    }
    .active{
        color: #fb6638!important;
    }
    .item{
        box-sizing: border-box;
        width: 100%;
        overflow: hidden;
    }
    .item>li{
        width: 50%;
        box-sizing: border-box;
        float: left;
        font-size: .75rem;
        line-height: .75rem;
        color: #7a7fa5;
        padding: 0 .625rem 1.5rem 0;
        text-align: left;
    }
    .btmcall{
        height: 3.0625rem;
        width: 100%;
        position: fixed;
        overflow: hidden;
        z-index: 7;
        bottom: 0;
        left: 0;
        transition: all .5s;
        background: linear-gradient(135deg,#ff6231,#ff3636);
    }
    .btmcall:after{
        opacity: .2;
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #000;
        width: .3125rem;
        height: .3125rem;
        border-radius: 50%;
        animation: app_blink 2s ease infinite;
    }
   @keyframes app_blink
   {
       from {width:.3125rem;height:.3152rem;opacity: .1;}
       to {width: 25rem;height:25rem;opacity: 0;}
   }
    .btmcall>img{
        position: absolute;
        width: 1.25rem;
        height: 1.25rem;
        left: 7.375rem;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .btmcall>span{
        line-height: 3.0625rem;
        text-align: center;
        width: 100%;
        height: 100%;
        float: left;
        font-size: .9rem;
        color: #fff;
    }
    ul{
        list-style: none;
        margin: 0;
        padding: 0;

    }

</style>



// WEBPACK FOOTER //
// src/components/phone/mindex.vue